import {Button} from 'antd';
import cn from 'classnames'
import _ from 'lodash'

import cls from './Quiz.module.scss';
export interface IAnswer {
    value: string
    label: string
    selected: boolean
}

export interface IQuestion {
    number: string
    question: string
    answers: IAnswer[]
    vertical?: boolean
    onSelect: (value: string) => void
}

export const Question = ({number, question, answers, vertical, onSelect}:IQuestion) => (
    <div className={cls.question}>
        <div className={cls.number}><span>{number}</span></div>
        <div>
            <h2>{question}</h2>
            <div className={cn([cls.buttons, vertical && cls.vertical])}>
                {_.map(answers, answer => (
                    <Button key={answer.value} onClick={() => onSelect(answer.value)} className={cn([answer.selected && cls.selected])}>{answer.label}</Button>
                ))}
            </div>
        </div>
    </div>
    )